// Create a vue app
import { createApp } from 'vue';
import Hikes from "./Hikes.vue";
import { i18n } from '../../i18n';

declare global {
  interface Window {
    hikesAppConfig?: Record<string, any>
  }
}

function mountHikesApp (elementId: string, config: Record<string, any>) {
  const el = document.getElementById(elementId)
  if (!el) return

  window.hikesAppConfig = config
  const app = createApp(Hikes)
  app.use(i18n);
  app.mount(`#${elementId}`)
}

if (document.getElementById('hikes')) {
  mountHikesApp('hikes', { context: 'private' })
} else if (document.getElementById('public-hikes-app')) {
  const el = document.getElementById('public-hikes-app') as HTMLElement
  let appConfig: Record<string, any> = { context: 'public' }
  if (el?.dataset?.appConfig) {
    try {
      appConfig = { ...appConfig, ...JSON.parse(el.dataset.appConfig) }
    } catch (e) {
      console.warn('Failed to parse hikes app config dataset:', e)
    }
  }
  mountHikesApp('public-hikes-app', appConfig)
}
